import { render, staticRenderFns } from "./g-assistant-import-orders-card.vue?vue&type=template&id=24b00c90&scoped=true&"
import script from "./g-assistant-import-orders-card.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-assistant-import-orders-card.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-assistant-import-orders-card.vue?vue&type=style&index=0&id=24b00c90&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b00c90",
  null
  
)

export default component.exports